import React, { useState, useEffect } from 'react';
import downloadAvatar from '../images/download.jpg';

const Header = () => {
  const [username, setUsername] = useState('');

  useEffect(() => {
    const storedUsername = sessionStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  return (
    <div className="hidden md:flex top-0 left-0 right-0 z-50 bg-gray-200 p-4 md:ml-28 lg:ml-64 h-16">
      <div className="flex items-center justify-between w-full">
        <div className="flex-1"></div>
        <div className="flex items-center space-x-2 ml-auto">
          <img
            src={downloadAvatar}
            alt="User Avatar"
            className="w-8 h-8 rounded-full"
          />
          <span className="text-gray-700 font-medium">
            {username || 'superadmin'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Header;
